/**
 * Proof-of-play service – dedupe 5 menit per item (sesuai spesifikasi).
 */

import { postWebosProofOfPlay } from '../repository.js';

const DEDUPE_MS = 5 * 60 * 1000;
const lastSentMsByKey = new Map();

function keyOf(body) {
  const pid = body?.playlist_id;
  const iid = body?.item_id;
  return `${pid}:${iid}`;
}

/**
 * Kirim proof-of-play tanpa menunggu response (fire-and-forget).
 * @param {string} token
 * @param {{ playlist_id:number, item_id:number, content_id:number, started_at:string }} body
 * @param {{ dedupeMs?: number }} [options]
 * @returns {{ sent: boolean, skippedReason?: string }}
 */
export function recordPlay(token, body, options = {}) {
  const dedupeMs = Number(options.dedupeMs ?? DEDUPE_MS);
  const k = keyOf(body);
  const now = Date.now();
  const last = lastSentMsByKey.get(k) || 0;
  if (last && now - last < dedupeMs) return { sent: false, skippedReason: 'dedupe' };

  lastSentMsByKey.set(k, now);

  // Fire-and-forget
  try {
    void postWebosProofOfPlay(token, body);
  } catch {
    // ignore
  }
  return { sent: true };
}
